<template>
  <CoverPage :cover="login_background_image">
    <div class="tw:flex tw:flex-col tw:gap-8">
      <img
        class="tw:max-w-[170px] tw:max-h-[80px] tw:object-contain tw:object-left"
        loading="lazy"
        :src="logo || logoVoomp"
        alt="logo"
      />
    </div>
    <div class="tw:flex tw:flex-col tw:gap-8">
      <div class="tw:flex tw:flex-col tw:gap-4">
        <ButtonPlayV2 icon="arrow_back" variant="outline" size="sm" :text="$t('general.back')" class="tw:self-start" @click="onBack" />
        <TextPlay tag="h1" text="Defina a sua senha" size="xl" weight="bold" />
        <TextPlay :text="$t('auth.set_password.description')" size="sm" weight="regular" />
      </div>
      <Form ref="observer" v-slot="{ errors }" class="tw:flex tw:flex-col tw:gap-5">
        <FormFieldPlay
          id="password"
          as="InputPlayV3"
          name="password"
          :label="$t('auth.set_password.password_label')"
          rules="required|min:8"
          :type="isShowingPass ? 'text' : 'password'"
          :placeholder="$t('auth.set_password.password_placeholder')"
          :right-icon="isShowingPass ? 'visibility' : 'visibility_off'"
          right-icon-clickable
          autocomplete="new-password"
          @right-icon-click="toggleShowingPass"
        />
        <FormFieldPlay
          id="password-confirm"
          as="InputPlayV3"
          name="password_confirm"
          :label="$t('auth.set_password.confirm_password_label')"
          rules="required|confirmed:@password"
          :type="isShowingPassConfirm ? 'text' : 'password'"
          :placeholder="$t('auth.set_password.confirm_password_placeholder')"
          :right-icon="isShowingPassConfirm ? 'visibility' : 'visibility_off'"
          right-icon-clickable
          autocomplete="new-password"
          @right-icon-click="toggleShowingPassConfirm"
        />
        <CaptchaButton type="normal" :text="'Alterar Senha'" :disabled="Object.keys(errors).length > 0" captcha="ADMIN" @click="onSubmit" />
      </Form>
    </div>
  </CoverPage>
</template>
<script lang="ts" setup>
import { toast } from '@/events';
import { ref, onMounted, computed } from 'vue';
import { useRouter, useRoute } from "vue-router"
import { useI18n } from "vue-i18n"
import { Form } from 'vee-validate';
import CoverPage from '@/components/common/CoverPage/CoverPage.vue';
import { useStateStore } from '@/store/state.store';
import { useAuthStore } from '@/store/auth.store';
import { CaptchaButton, ButtonPlayV2, FormFieldPlay } from "@/components/atomic"
import defaultCover from '@/assets/img/default_cover.png';
import logoVoomp from '@/assets/img/logo_voomp.png';


const stateStore = useStateStore()
const authStore = useAuthStore()

const route = useRoute()
const router = useRouter()
const { t } = useI18n()
const token = ref('');
const email = ref('');
const isShowingPass = ref(false);
const isShowingPassConfirm = ref(false);
const observer = ref<InstanceType<typeof Form> & { values?: Record<string, string> } | null>(null)

const login_background_image = computed(() => {
  return stateStore.site['login_background_image'] || defaultCover
})

const logo = computed(() => {
  return stateStore.site?.['logomarca'] || stateStore.site?.['logo']
})

function toggleShowingPass() {
  isShowingPass.value = !isShowingPass.value;
}

function toggleShowingPassConfirm() {
  isShowingPassConfirm.value = !isShowingPassConfirm.value;
}

function onBack() {
  router.replace('/sign-in');
}

async function onSubmit(captcha: string) {
  const values = observer.value?.values
  
  if (!values?.password) {
    return
  }

  try {
    const response = await authStore.setPassword({
      token: token.value,
      email: email.value,
      password: values.password,
      captcha
    });
    toast.success(t('set_password.messages.password_set_successfully'));
    router.replace(response);
  } catch (_error) {
    toast.error(
      t('Erro ao reenviar e-mail'),
    );
  }
}

onMounted(() => {
  token.value = route.query.token as string;
  email.value = route.query.email as string;

  router.replace({
    query: {}
  })
});

</script>
